'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:project-list
 * @description
 * # project-list
 * Directive to generate a project index
 */
angular.module('thothApp.directives')
.directive('projectList', function() {
  return {
    restrict: 'E',
    scope: {
      projectId: '=',
      canExtend: '=',
      display: '='
    },
    templateUrl: 'views/projects/_list.html',
    controller: ['$scope', '$rootScope', '$state', 'Project', 'Pagination', '$mdDialog', 'ProjectTypeCatalog',
    'SessionStorage', 'ProductCatalog' , 'toaster', 'FileSaver','$window', '$q' , 'Employee', 'ProjectActions',
    function ($scope, $rootScope, $state, Project, Pagination, $mdDialog, ProjectTypeCatalog, SessionStorage,
      ProductCatalog, toaster, FileSaver, $window, $q, Employee, ProjectActions) {

      function projectParentId() {
        var parentId = '';
        if($scope.projectId) {
          parentId = $scope.projectId;
        }
        return parentId;
      }
      var vigentes = [];
      var archivados = [];
      $scope.statusList = [
        {
          name: 'Todos',
          id: ''
        },
        {
          name: 'Vigentes',
          id: 2
        },
        {
          name: 'Archivados',
          id: 3
        },
      ];

      $scope.search = {
        'search': '',
        'by_column': '',
        'by_project_type': [],
        'project_type_filters': [],
        'by_product': [],
        'product_filters': [],
        'by_status': [],
        'status_filters': [],
        'pager': {
          'currentPage': 1
        },
        'filters': {
          'project_code': 'fa-sort-asc',
          'name': 'fa-sort',
          'client_id': 'fa-sort',
          'rape_id': 'fa-sort',
          'state': 'fa-sort',
          'project_date': 'fa-sort',
          'created_at': 'fa-sort',
        }
      };

      if(SessionStorage.existsInSessionStorage('projects' + projectParentId())) {
        $scope.search = SessionStorage.getFromSessionStorage('projects' + projectParentId());
      } else {
        SessionStorage.saveToSessionStorage('projects' + projectParentId(), $scope.search);
      }
      $scope.projectTypeList = [];
      $scope.productList = [];

      $scope.project_type_selected = '';
      $scope.product_selected = '';
      $scope.status_selected = $scope.statusList[0];


      $scope.clearSearch = function() {
        $scope.search = {
          'search': '',
          'by_column': '',
          'by_project_type': $scope.search.by_project_type,
          'project_type_filters': $scope.search.project_type_filters,
          'by_product': $scope.search.by_product,
          'product_filters': $scope.search.product_filters,
          'by_status': $scope.search.by_status,
          'status_filters': $scope.search.status_filters,
          'pager': {
            'currentPage': 1
          },
          'filters': {
            'project_code': 'fa-sort-asc',
            'name': 'fa-sort',
            'client_id': 'fa-sort',
            'rape_id': 'fa-sort',
            'state': 'fa-sort',
            'project_date': 'fa-sort',
            'created_at': 'fa-sort',
          }
        };
        SessionStorage.saveToSessionStorage('projects' + projectParentId(), $scope.search);
        $scope.getPage($scope.search.pager.currentPage);
      };

      $scope.downloadProjects = function() {
        var search = $scope.search.search.replace(/SCISA_0+(\d)|0+(\d)/, '$1$2');
        var params =  {
          params: {
            per_page: "all",
            search: search,
            by_column: $scope.search.by_column,
            by_project_parent: projectParentId(),
            by_project_type: JSON.stringify($scope.search.by_project_type),
            by_product: JSON.stringify($scope.search.by_product),
            by_status: JSON.stringify($scope.search.by_status)
          }
        };
        if ($scope.employeeId !== null && $scope.employeeId !== undefined) {
          params.params.involved_projects_by_employee = JSON.stringify($scope.employeeId);
        }
        Project.downloadProjects(params).then(function(response) {
          var blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          FileSaver.saveAs(blob, 'SCISA_Proyectos.csv');
        }, function(error) {
          Project.error(error);
        });
      };

      $scope.redirigirTableroProyectos = function() {
        $window.location.href = process.env.DASHBOARDS_URL;
      };

      $scope.getPage = function(page, optionalParams) {
        if($scope.search.project_type_filters.includes('Todos')) {
          $scope.search.project_type_filters = [];
          $scope.search.by_project_type = [];
        }
        if($scope.search.product_filters.includes('Todos')) {
          $scope.search.product_filters = [];
          $scope.search.by_product  = [];
        }
        if ($scope.search.status_filters.includes('Todos')) {
          $scope.search.status_filters = [];
          $scope.search.by_product = [];
        }
        var search = $scope.search.search.replace(/^SCISA_0*(\d+)|^0*(\d+)/, function(match, p1, p2) {
          return p1 || p2;
        });
        var params = optionalParams || {
          params: {
            page: page,
            per_page: 10,
            search: search,
            by_column: $scope.search.by_column,
            by_project_parent: projectParentId(),
            by_project_type: JSON.stringify($scope.search.by_project_type),
            by_product: JSON.stringify($scope.search.by_product),
            by_status: JSON.stringify($scope.search.by_status)
          }
        };
        if ($scope.employeeId !== null && $scope.employeeId !== undefined) {
          params.params.involved_projects_by_employee = JSON.stringify($scope.employeeId);
        }
        Project.index(params).then(function(response) {
          $scope.projects = response.data.projects;
          $scope.search.pager = Pagination.GetPager(
            response.data.meta.pagination.total_objects,
            page,
            response.data.meta.pagination.per_page
          );
          if(response.data.projects.length > 0) {
            response.data.projects[0].aasm_statuses_with_i18n.map(function(x) {
              if (x.name === 'No Autorizado' || x.name === 'Cancelado' || x.name === 'Terminado') {
                if (!archivados.includes(x.id)) {
                  archivados.push(x.id);
                }
              }else {
                if (!vigentes.includes(x.id)) {
                  vigentes.push(x.id);
                }
              }
            });
          }
          SessionStorage.saveToSessionStorage('projects' + projectParentId(), $scope.search);

        },function(error) {
          Project.error(error);
        });
      };

      //Nesting of Responses to avoid triggering errors mutiple times.
      ProjectTypeCatalog.index().then(function(response) {
        // jscs:disable
        $scope.projectTypeList = response.data.project_types;
        $scope.projectTypeList.unshift({name: 'Todos', id: '', color_tag: '#E0E0E0'});
        // jscs:enable
        $scope.project_type_selected = $scope.projectTypeList[0];

        ProductCatalog.index().then(function(response) {
          // jscs:disable
          $scope.productList = response.data.products;
          $scope.productList.unshift({name: 'Todos', id: ''});
          // jscs:enable
          $scope.product_selected = $scope.productList[0];
        }, function(error) {
          ProductCatalog.error(error);
        });

        $scope.getPage($scope.search.pager.currentPage);
      }, function(error) {
        ProjectTypeCatalog.error(error);
      });

      $scope.filter = function(column) {
        var order = '';
        angular.forEach($scope.search.filters, function(value, key) {
          if(column === key) {
            if($scope.search.filters[key] === 'fa-sort-desc') {
              $scope.search.filters[key] = 'fa-sort-asc';
              order = 'ASC';
            } else {
              $scope.search.filters[key] = 'fa-sort-desc';
              order = 'DESC';
            }
          } else {
            $scope.search.filters[key] = 'fa-sort';
          }
        });
        $scope.search.by_column = {
          column: column,
          order: order
        };
        $scope.getPage(1);
      };

      $scope.addFilter = function() {
        if(!$scope.search.by_project_type.includes($scope.project_type_selected.id)) {
          $scope.search.by_project_type.push($scope.project_type_selected.id);
          $scope.search.project_type_filters.push($scope.project_type_selected.name);
          $scope.getPage(1);
        }
      };
      $scope.addProductFilter = function() {
        if(!$scope.search.by_product.includes($scope.product_selected.id)) {
          $scope.search.by_product.push($scope.product_selected.id);
          $scope.search.product_filters.push($scope.product_selected.name);
          $scope.getPage(1);
        }
      };
      $scope.employeeSearch = function(searchQuery) {
        if (!searchQuery) {
          return [];
        }
        var employeeParams = {
          'params': {
            'search': searchQuery
          }
        };

        var deferred = $q.defer();
        Employee.index(employeeParams).then(function(response) {
          let response_data = response.data.employees;
          deferred.resolve(response_data);
        }).catch(function(error) {
          Employee.error(error);
          deferred.reject(error);
        });
        return deferred.promise;
      };

      $scope.selectedEmployeeChange = function(employee) {
        if (employee === undefined) {
          $scope.selectedEmployee = undefined;
          $scope.employeeId = null;
          $scope.getPage(1);
        } else {
          $scope.employeeId = employee.id;
          $scope.getPage(1);
        }
      };
      $scope.addStatusFilter = function(){
        if (!$scope.search.by_status.includes($scope.status_selected.id)) {
          switch ($scope.status_selected.name) {
            case 'Vigentes':
              $scope.search.by_status = vigentes;
              break;
            case 'Archivados':
              $scope.search.by_status = archivados;
              break;
            case 'Todos':
              $scope.search.by_status = [];
              break;
            default:
          }
          $scope.search.status_filters.push($scope.status_selected.name);
          if ($scope.search.status_filters.length > 1) {
            $scope.search.status_filters.splice(0, 1);
          }
          $scope.getPage(1);
        }
      };
      $scope.removeFilter = function(index) {
        $scope.search.by_project_type.splice(index, 1);
        $scope.search.project_type_filters.splice(index, 1);
        if($scope.search.by_project_type.length === 0) {
          $scope.project_type_selected = $scope.projectTypeList[0];
        }
        $scope.getPage(1);
      };
      $scope.removeProductFilter = function(index) {
        $scope.search.by_product.splice(index, 1);
        $scope.search.product_filters.splice(index, 1);
        if($scope.search.by_product.length === 0) {
          $scope.product_selected = $scope.productList[0];
        }
        $scope.getPage(1);
      };
      $scope.removeStatusFilter = function(index) {
        $scope.search.by_status = [];
        $scope.status_selected = $scope.statusList[0];
        $scope.search.status_filters.splice(index, 1);
        $scope.getPage(1);
      };

      $scope.extendProject = function(project) {
        ProjectActions.extendProject($scope, project);
      };
    }]
  };
});
